import { reportParentsCodes, ReportType, reportTypesChildren, reportTypesTitleKeys } from '../models/report-type';
import { HttpService } from './http';
export class ReportTypeService {
  static async getReportTypes() {
    try {
      const data = await HttpService.get('v2', '/report_types');
      const _reportTypesMap = data.reduce((res, typeData) => {
        const type = parseReportType(typeData);
        if (type) res[type.code] = type;
        return res;
      }, {});
      return reportParentsCodes.map(parentKey => {
        const {
          isBindToOSM,
          children
        } = reportTypesChildren[parentKey];
        return new ReportType(_reportTypesMap[parentKey]?.id || -1, parentKey, isBindToOSM, reportTypesTitleKeys[parentKey], children.reduce((res, childKey) => {
          const child = _reportTypesMap[childKey];
          if (child) res.push(child);
          return res;
        }, []));
      });
    } catch (err) {
      console.error('[ReportTypeService][getReportTypes]', err);
      return [];
    }
  }
}
export const reportTypesCodes = {
  ACCIDENT: 'accident',
  BARRIER: 'barrier',
  BICYCLE_DAMMAGE: 'bicycleDammage',
  BICYCLE_FACILITY_REQUEST: 'bicycleFacilityRequest',
  BICYCLE_PARKING_REQUEST: 'bicycleParkingRequest',
  BIKE_FACILITY: 'bikeFacility',
  BIKE_PARKING_BOLLARD: 'bikeParkingBollard',
  BIKE_PARKING_LOCKERS: 'bikeParkingLockers',
  BIKE_PARKING_SHED: 'bikeParkingShed',
  BIKE_PARKING_STANDS: 'bikeParkingStands',
  BIKE_PARKING_WALL_LOOP: 'bikeParkingWallLoop',
  BROKEN_GLASS: 'brokenGlass',
  CARTOGRAPHIC_ISSUE: 'cartographicIssue',
  COLLISION_WITH_BICYCLE: 'collisionWithBicycle',
  COLLISION_WITH_CAR_DOOR: 'collisionWithCarDoor',
  COLLISION_WITH_PEDESTRIAN: 'collisionWithPedestrian',
  COLLISION_WITH_VEHICLE: 'collisionWithVehicule',
  DANGEROUS: 'dangerous',
  DANGEROUS_CROSSING: 'dangerousCrossing',
  DEAD_LEAVES: 'deadLeaves',
  DEGRADED_ROAD_SURFACE: 'degradedRoadSurface',
  EVENT_ON_ROAD: 'eventOnRoad',
  EXCLUSION_ZONE: 'exclusionZone',
  FALL: 'fall',
  FLOOD: 'flood',
  FREEZING_RAIN: 'freezingRain',
  GCUM: 'gcum',
  HEAVY_BICYCLE_TRAFFIC: 'heavyBicycleTraffic',
  HEAVY_CAR_TRAFFIC: 'heavyCarTraffic',
  HEAVY_PEDESTRIAN_TRAFFIC: 'heavyPedestrianTraffic',
  KERB: 'kerb',
  MISSING_TRAFFIC_SIGN: 'missingTrafficSign',
  NO_LIGHTING: 'noLighting',
  NO_MARKING: 'noMarking',
  PEBBLES: 'pebbles',
  POLE: 'pole',
  POLICE_PRESENCE: 'policePresence',
  POTHOLE: 'pothole',
  ROAD_BLOCKED: 'roadBlockedOther',
  ROADWORK: 'roadwork',
  ROOTS: 'roots',
  SNOW: 'snow',
  SUPPORT: 'support',
  SUPPORT_LOCAL_AUTHORITIES: 'supportLocalAuthorities',
  THEFT: 'theft',
  TO_DO_TO_SEE: 'toDoToSee',
  UNLISTED_CHARGING_STATION: 'unlistedChargingStation',
  UNLISTED_BICYCLE_PUMP: 'unlistedBicyclePump',
  UNLISTED_BICYCLE_REPAIR: 'unlistedBicycleRepair',
  UNLISTED_PICNIC_AREA: 'unlistedPicnicArea',
  UNLISTED_TOILETS: 'unlistedToilets',
  UNLISTED_WATER_POINT: 'unlistedWaterPoint',
  VEGETATION: 'vegetation'
};
export const backendReportTypesCodes = {
  // trafficConditions
  heavyCarTraffic: 'HEAVY_CAR_TRAFFIC',
  heavyPedestrianTraffic: 'HEAVY_PEDESTRIAN_TRAFFIC',
  policePresence: 'POLICE_PRESENCE',
  heavyBicycleTraffic: 'HEAVY_BICYCLE_TRAFFIC',
  // roadBlocked
  badWeather: ['SNOW', 'FLOOD'],
  snow: 'SNOW',
  flood: 'FLOOD',
  roadwork: 'ROADWORK',
  roadBlockedObstacle: 'ROAD_BLOCKED',
  eventOnRoad: 'EVENT_ON_ROAD',
  roadBlockedOther: 'ROAD_BLOCKED',
  // danger
  accident: ['COLLISION_WITH_VEHICLE', 'COLLISION_WITH_CAR_DOOR', 'COLLISION_WITH_BICYCLE', 'FALL', 'COLLISION_WITH_PEDESTRIAN', 'ACCIDENT'],
  collisionWithVehicule: 'COLLISION_WITH_VEHICLE',
  collisionWithCarDoor: 'COLLISION_WITH_CAR_DOOR',
  collisionWithBicycle: 'COLLISION_WITH_BICYCLE',
  fall: 'FALL',
  collisionWithPedestrian: 'COLLISION_WITH_PEDESTRIAN',
  accidentOther: 'ACCIDENT',
  dangerous: ['KERB', 'BROKEN_GLASS', 'FREEZING_RAIN', 'DEAD_LEAVES', 'PEBBLES', 'DANGEROUS_CROSSING', 'DANGEROUS'],
  kerb: 'KERB',
  brokenGlass: 'BROKEN_GLASS',
  freezingRain: 'FREEZING_RAIN',
  deadLeaves: 'DEAD_LEAVES',
  pebbles: 'PEBBLES',
  dangerousCrossing: 'DANGEROUS_CROSSING',
  dangerousOther: 'DANGEROUS',
  obstacles: ['BARRIER', 'VEGETATION', 'GCUM', 'POLE', 'ROAD_BLOCKED'],
  barrier: 'BARRIER',
  vegetation: 'VEGETATION',
  gcum: 'GCUM',
  pole: 'POLE',
  obstaclesOther: 'ROAD_BLOCKED',
  needMaintenance: ['POTHOLE', 'ROOTS', 'DEGRADED_ROAD_SURFACE'],
  pothole: 'POTHOLE',
  roots: 'ROOTS',
  degradedRoadSurface: 'DEGRADED_ROAD_SURFACE',
  incivilities: ['THEFT', 'BICYCLE_DAMMAGE'],
  theft: 'THEFT',
  bicycleDammage: 'BICYCLE_DAMMAGE',
  dangerOther: 'DANGEROUS',
  // mapError
  bikeFacility: 'BIKE_FACILITY',
  bikeParkings: ['BIKE_PARKING_STANDS', 'BIKE_PARKING_LOCKERS', 'BIKE_PARKING_BOLLARD', 'BIKE_PARKING_WALL_LOOP', 'BIKE_PARKING_SHED'],
  bikeParkingStands: 'BIKE_PARKING_STANDS',
  bikeParkingLockers: 'BIKE_PARKING_LOCKERS',
  bikeParkingBollard: 'BIKE_PARKING_BOLLARD',
  bikeParkingWallLoop: 'BIKE_PARKING_WALL_LOOP',
  bikeParkingShed: 'BIKE_PARKING_SHED',
  unlistedBicycleService: ['UNLISTED_BICYCLE_PUMP', 'UNLISTED_BICYCLE_REPAIR', 'UNLISTED_CHARGING_STATION', 'UNLISTED_TOILETS', 'UNLISTED_PICNIC_AREA', 'UNLISTED_WATER_POINT'],
  unlistedBicyclePump: 'UNLISTED_BICYCLE_PUMP',
  unlistedBicycleRepair: 'UNLISTED_BICYCLE_REPAIR',
  unlistedChargingStation: 'UNLISTED_CHARGING_STATION',
  unlistedToilets: 'UNLISTED_TOILETS',
  unlistedPicnicArea: 'UNLISTED_PICNIC_AREA',
  unlistedWaterPoint: 'UNLISTED_WATER_POINT',
  cartographicIssue: 'CARTOGRAPHIC_ISSUE',
  // needFacility
  bicycleFacilityRequest: 'BICYCLE_FACILITY_REQUEST',
  bicycleParkingRequest: 'BICYCLE_PARKING_REQUEST',
  missingTrafficSign: 'MISSING_TRAFFIC_SIGN',
  noMarking: 'NO_MARKING',
  noLighting: 'NO_LIGHTING',
  // supportLocalAuthorities
  supportLocalAuthorities: 'SUPPORT_LOCAL_AUTHORITIES',
  // others
  exclusionZone: 'EXCLUSION_ZONE',
  toDoToSee: 'TO_DO_TO_SEE',
  support: 'SUPPORT'
};
function parseReportType({
  id,
  code: _code,
  is_bind_to_osm: isBindToOSM
}) {
  const code = reportTypesCodes[_code];
  if (!code) return null;
  return new ReportType(id, code, isBindToOSM, reportTypesTitleKeys[code], []);
}